import { useSelector } from "react-redux";
import Aside3Filter from "./Aside3Filter";
import { getL1SheetProperty } from "../../WorkbookSlice";
import { useEffect, useMemo } from "react";

const Aside3FilterSidebar = ({
  Sheetid,
  showFilters,
  isFilterVisibleInDashboard,
  filterArray,
  commonFilters,
}) => {
  const dataSourceID = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "dataSourceID")
  );

  // Fetch the filter array from the Redux store
  const visibleFiltersArray = useMemo(() => {
    return Array.isArray(filterArray)
      ? filterArray.filter((filter) => filter.visibleFilter)
      : [];
  }, [filterArray]);
  const relativeDateFilterArray = useMemo(() => {
    return Array.isArray(filterArray)
      ? filterArray.filter(
          (filter) => filter.visibleFilter && filter.isRelativeDate
        )
      : [];
  }, [filterArray]);
  // useEffect(() => {
  //   // console.log(relativeDateFilterArray);
  // }, [relativeDateFilterArray]);
  // useEffect(() => {
  //   // console.log(visibleFiltersArray);
  // }, [visibleFiltersArray]);

  if (visibleFiltersArray.length || showFilters) {
    return (
      <main className="border-l h-full overflow-x-hidden overflow-y-auto w-full flex flex-col">
        {visibleFiltersArray.map((item, index) => {
          // console.log(item.rename);
          return (
            <Aside3Filter
              key={item.nanoId}
              item={item}
              index={index}
              Sheetid={Sheetid}
              filterArray={visibleFiltersArray}
              dataSourceID={dataSourceID}
              isFilterVisibleInDashboard={isFilterVisibleInDashboard}
              commonFilters={commonFilters}
              currentSheetType={"chart"}
              dashboardType={"makeDashboard"}
            />
          );
        })}
      </main>
    );
  }
};

export { Aside3FilterSidebar };
